import { onPreferencesChange, preferencesAllowed } from '@theme/yvicor-preferences-consent';

/** Recently viewed products, using only this feature's existing storage key. */
export class RecentlyViewed {
  static #STORAGE_KEY = 'viewedProducts';
  static #MAX_PRODUCTS = 4;
  static #currentProduct = null;

  /** Keep only the currently open product in memory until preferences are allowed. */
  static addProduct(productId) {
    if (typeof productId !== 'string' || !/^\d+$/.test(productId)) return;
    this.#currentProduct = productId;
    if (!preferencesAllowed()) return;
    const viewedProducts = this.getProducts().filter(id => id !== productId);
    viewedProducts.unshift(productId);
    try {
      localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts.slice(0, this.#MAX_PRODUCTS)));
    } catch {
      // A blocked or full storage must not break search or the product page.
    }
  }

  static clearProducts() {
    try { localStorage.removeItem(this.#STORAGE_KEY); } catch { /* Storage may be blocked. */ }
  }

  static getProducts() {
    if (!preferencesAllowed()) return [];
    try {
      const stored = JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
      if (!Array.isArray(stored)) return [];
      return [...new Set(stored.filter(id => typeof id === 'string' && /^\d+$/.test(id)))].slice(0, this.#MAX_PRODUCTS);
    } catch {
      return [];
    }
  }

  static restoreCurrentProduct() {
    if (this.#currentProduct && preferencesAllowed()) this.addProduct(this.#currentProduct);
  }
}

let recentlyViewedWasAllowed = false;
onPreferencesChange((allowed, reason) => {
  if (allowed) RecentlyViewed.restoreCurrentProduct();
  else if (recentlyViewedWasAllowed || reason === 'consent') RecentlyViewed.clearProducts();
  recentlyViewedWasAllowed = allowed;
});
